import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';
import { useClickOutside } from 'stimulus-use';

export default class extends Controller {
  static targets = ['frame'];

  static values = {
    modalUrl: String,
  };

  connect() {
    useClickOutside(this);
  }

  clickOutside = () => {
    this.close();
  };

  toggle = () => {
    if (this.frameTarget.hasChildNodes()) {
      this.close();
      return;
    }

    const currentURL = new URL(window.location.href);
    const modalURL = new URL(this.modalUrlValue);

    currentURL.searchParams.forEach((value, key) => {
      modalURL.searchParams.append(key, value);
    });

    const { id } = this.frameTarget;
    modalURL.searchParams.append('frame', id);

    this.close();
    Turbo.visit(modalURL, { frame: id });
  };

  close() {
    // Remove src from frame so that it is not loaded again when the page is
    // restored from cache:
    this.frameTarget.removeAttribute('src');

    // Remove all frame content:
    this.frameTarget.innerHTML = '';
  }
}
